export function todayDate() {
	const date = new Date();
	date.setHours(0, 0, 0, 0);

	return date;
}

export function startOfDay() {
	const now = new Date();
	return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}